import { DuplicateApplicationPageFunctions } from '../types';
import { applicationYear } from './applicationYear';

export const RnDActivities: DuplicateApplicationPageFunctions = {
    applicationYear,
};
